import { transformDateValue } from 'core/js/FormUtils';
export const getMlmcreditView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mlmcreditList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Credit Level","fieldValue":transformDataValue(data.creditlevel,"number"), "fieldType":"number"},
                            {"fieldLabel":"Credit Value","fieldValue":transformDataValue(data.creditvalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Sr Partner Id","fieldValue":transformDataValue(data.srpartnerid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Sr Partner Name","fieldValue":transformDataValue(data.srpartnername,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Value","fieldValue":transformDataValue(data.ordervalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Credit Percentage","fieldValue":transformDataValue(data.creditpercentage,"double"), "fieldType":"double"},
                            {"fieldLabel":"Payment Id","fieldValue":transformDataValue(data.paymentid,"string"), "fieldType":"string"},
                            {"fieldLabel":"Credit Type","fieldValue":transformDataValue(data.credittype,"number"), "fieldType":"number"},
                            {"fieldLabel":"Credit Date","fieldValue":transformDataValue(data.creditdate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Credit Status Id","fieldValue":transformDataValue(data.creditstatusid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"User Id","fieldValue":transformDataValue(data.userid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"TransferReqId","fieldValue":transformDataValue(data.transferreqid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mlmcreditList.push(card);
  })
  return mlmcreditList;
}